export const SAVE_LOYALTY_REWARD = 'SAVE_LOYALTY_REWARD';
export const CLEAR_LOYALTY_REWARD = 'CLEAR_LOYALTY_REWARD';

export function reducer(state: any = {}, action) {
  switch (action.type) {
    case SAVE_LOYALTY_REWARD:
      return action.payload;
    case CLEAR_LOYALTY_REWARD:
      return {};
    default:
      return state;
  }
}